import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "articles__img-box" }
const _hoisted_2 = {
  key: 1,
  class: "articles__play"
}
const _hoisted_3 = { class: "articles__text-box" }
const _hoisted_4 = { class: "articles__text" }
const _hoisted_5 = {
  key: 0,
  class: "articles__category card__category"
}
const _hoisted_6 = { class: "articles__title card__title" }
const _hoisted_7 = { class: "articles__author card__author" }
const _hoisted_8 = { class: "articles__bottom-box" }

import { computed } from 'vue'

import type { ArticlesView } from '@/models/doc.article'
import type { ArticleListItem } from '@/models/interfaces'

import DocBadges from '@/app/components/doc/DocBadges.vue'
import DocMoreMenu from '@/app/components/doc/DocMoreMenu.vue'
import DocTypeBadge from '@/app/components/doc/DocTypeBadge.vue'
import SaveButton from '@/app/components/doc/SaveButton.vue'
import TimeEstimate from '@/app/components/doc/TimeEstimate.vue'
import FavoriteFlag from '@/app/components/listing/FavoriteFlag.vue'
import LazyImage from '@/app/components/podcast/card/LazyImage.vue'
import { saveForLater20321Treatment } from '@/services/ab/experiments'


export default /*@__PURE__*/_defineComponent({
  __name: 'Card',
  props: {
    view: {},
    doc: {}
  },
  setup(__props: any) {

const props = __props

const showNewSaveDesign = saveForLater20321Treatment()

const isCTA = computed(() => {
  return props.doc.title === 'CTA'
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (!isCTA.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["articles__item", { 'articles__item--20321B': _unref(showNewSaveDesign) }])
      }, [
        (_unref(showNewSaveDesign) && __props.view.hasUserData(__props.doc))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(SaveButton, {
                class: "articles__save-button",
                doc: __props.doc,
                docsView: __props.view
              }, null, 8, ["doc", "docsView"]),
              _createVNode(DocMoreMenu, {
                class: "articles__more-menu",
                doc: __props.doc,
                docsView: __props.view
              }, null, 8, ["doc", "docsView"])
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          to: __props.view.startLinkParams(__props.doc),
          class: "articles__link"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_unref(showNewSaveDesign))
                ? (_openBlock(), _createBlock(DocTypeBadge, {
                    key: 0,
                    docType: "article"
                  }))
                : (__props.doc.has_audio)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("span", { class: "articles__play-icon iconfont iaudio" }, null, -1)
                    ]))]))
                  : _createCommentVNode("", true),
              _createVNode(LazyImage, {
                src: __props.doc.cover_thumbnail,
                crossorigin: "anonymous",
                class: "articles__img",
                alt: ""
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (!_unref(showNewSaveDesign))
                  ? (_openBlock(), _createElementBlock("h5", _hoisted_5, _toDisplayString(__props.view.firstTag(__props.doc)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("h3", _hoisted_6, _toDisplayString(__props.doc.title), 1),
                _createElementVNode("h4", _hoisted_7, _toDisplayString(_unref(showNewSaveDesign) ? __props.doc.author : `By ${__props.doc.author}`), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                (_unref(showNewSaveDesign))
                  ? (_openBlock(), _createBlock(DocBadges, {
                      key: 0,
                      doc: __props.doc
                    }, null, 8, ["doc"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(TimeEstimate, { doc: __props.doc }, null, 8, ["doc"]),
                      (__props.view.hasUserData(__props.doc))
                        ? (_openBlock(), _createBlock(FavoriteFlag, {
                            key: 0,
                            class: "articles__collection collection",
                            doc: __props.doc,
                            docsView: __props.view
                          }, null, 8, ["doc", "docsView"]))
                        : _createCommentVNode("", true)
                    ], 64))
              ])
            ])
          ]),
          _: 1
        }, 8, ["to"])
      ], 2))
    : _createCommentVNode("", true)
}
}

})